import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/rich-button/rich-button.js';
      import {HTMLTemplateResult} from 'lit';
import {RichButtonDirection} from '@oicl/openbridge-webcomponents/dist/components/rich-button/rich-button.js';

      export interface Props {
     label?: string | HTMLTemplateResult;
     description?: string;
     direction?: RichButtonDirection;
     hasLeadingIcon?: boolean;
     hasTrailingIcon?: boolean;
     disabled?: boolean;
     fullWidth?: boolean;
     fullHeight?: boolean
   }

      
  
      export type {HTMLTemplateResult} from 'lit';
export type {RichButtonDirection} from '@oicl/openbridge-webcomponents/dist/components/rich-button/rich-button.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcRichButton',
  props: {
    label: {},
    description: {},
    direction: {},
    hasLeadingIcon: { type: Boolean },
    hasTrailingIcon: { type: Boolean },
    disabled: { type: Boolean },
    fullWidth: { type: Boolean },
    fullHeight: { type: Boolean }
  },
  emits: ["rich-button-click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onRichButtonClick: (event: CustomEvent<{label: string, description: string}>) => emit('rich-button-click', event as CustomEvent<{label: string, description: string}>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-rich-button',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})